import { AppParam } from 'components/AppFormLayout/AppFormAction';
import React, { Fragment } from 'react';

export interface Props {
  component: string
  paramlist?: AppParam[]
}
export const AppComponent = (props: Props) => {
  let params: { [name: string]: any } = {};
  (props.paramlist && props.paramlist.map(p => params[p.name] = p.value))
  const renderComponent = () => {
    if (props.component && props.component !== '') {
      const Component = require('modules/' + props.component).default
      return <Component {...params} />
    }
    return <Fragment></Fragment>
  }
  return <Fragment>{renderComponent()}</Fragment>
}



// WEBPACK FOOTER //
// ./src/components/AppComponent/AppComponent.tsx